import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshEvaluationListService {
  private refreshSubject = new Subject<void>();
  isTooltipChanged: boolean = false;
  action: string = '';

  get refreshObservable() {
    return this.refreshSubject.asObservable();
  }
  triggerRefresh(action: string) {
    this.action = action;
    this.refreshSubject.next();
  }
  triggerTooltip() {
    this.isTooltipChanged = true;
    this.refreshSubject.next();
  }
}